import script from "./log.vue?vue&type=script&setup=true&lang=js"
export * from "./log.vue?vue&type=script&setup=true&lang=js"

import "./log.vue?vue&type=style&index=0&id=6bea6572&lang=less"

const __exports__ = script;

export default __exports__